import { NextPageContextEnhanced } from "../../../types/page";
import {
  __fetchArrayBuffer,
  __fetchVerticalServerSide,
} from "../../../private/__fetch";
import {
  IJobPosterPostView,
  IJobSeekerPostView, IJobsSimilarPost, IOpeningJobsRecommendedPostData,
  IOpeningJobsSimilarPostData,
  IOpeningJobsSimilarPosts,
} from "models/jobPostView";
import { fetchVerticalAtClientSide } from "utils/misc/fetchClient";

export const JOB_POSTER_EXPANDS = ["dynamicAttributesObject", "postTags"];
export const JOB_SEEKER_EXPANDS = ["postTags","roleOption"];

export const enhancedJobPosterResponse = (
  data: IJobPosterPostView,
  source: string,
  lang: string,
  reqUrl: string
): IJobPosterPostView => {
  const pageTitle = data.card.title;
  const description = data.sections.filter((sec) => {
    return sec.module == "description";
  })[0].text;
  const postGeneralInfo = data.sections.filter((sec) => {
    return sec.module == "general_info" && !sec.label;
  })[0];

  if (source == "desktop") {
    const location = data.sections
      .filter((sec) => {
        return (
          sec.module == "general_info" &&
          sec.label == (lang == "en" ? "Job Info" : "المعلومات")
        );
      })[0]
      .items.filter((item) => {
        return item.view_type == "map";
      })[0];
    const mapModule = {
      module: "map",
      label: location.label,
      values: location.values,
    };
    const generalAdviceModule = data.sections.filter((sec) => {
      return sec.module == "general_advice";
    })[0];
    const paymentModule = data.sections.filter((sec) => {
      return sec.module == "payment";
    })[0];

    const memberCardModule = data.sections.filter((sec) => {
      return sec.module == "member_card";
    })[0];

    data = JSON.parse(
      JSON.stringify(data).replace(
        `,${JSON.stringify(generalAdviceModule)}`,
        ""
      )
    );
    data = JSON.parse(
      JSON.stringify(data).replace(`,${JSON.stringify(paymentModule)}`, "")
    );
    data = JSON.parse(
      JSON.stringify(data).replace(`,${JSON.stringify(postGeneralInfo)}`, "")
    );
    data = JSON.parse(
      JSON.stringify(data).replace(`,${JSON.stringify(memberCardModule)}`, "")
    );
    data.extraData = {
      generalAdvice: generalAdviceModule,
      location: mapModule?.values && mapModule?.values[0].split(","),
      member: memberCardModule?.member,
      postedDate: postGeneralInfo?.items[1],
      adNo: postGeneralInfo?.items[0],
    };
  }

  if (data.extraData == undefined) {
    data.extraData = {
      seoData: {},
    };
  }
  data.extraData.seoData = {
    postId: postGeneralInfo.items[0].values[0],
    pageTitle,
    description,
    postUrl: `/${lang}${reqUrl}`,
    link2: `/${lang == "ar" ? "en" : "ar"}${reqUrl}`,
  };
  return data;
};
export const enhancedJobSeekerResponse = (
  data: IJobSeekerPostView,
  source: string,
  lang: string,
  reqUrl: string
): IJobSeekerPostView => {
  const pageTitle = data.card.name;
  const AboutSummary = data.sections
    .filter((sec) => {
      return sec.module == "general_info";
    })[0]
    .items.filter((item) => {
      return item.label == (lang == "ar" ? "نبذة" : "About Summary");
    });
  if (source == "desktop") {
    const generalAdviceModule = data.sections.filter((sec) => {
      return sec.module == "general_advice";
    })[0];
    data = JSON.parse(
      JSON.stringify(data).replace(
        `,${JSON.stringify(generalAdviceModule)}`,
        ""
      )
    );
    if (AboutSummary.length && AboutSummary[0]) {
      data = JSON.parse(
        JSON.stringify(data).replace(`${JSON.stringify(AboutSummary[0])},`, "")
      );
    }
    const AboutSummaryModule = {
      module: "about_summary",
      label: AboutSummary.length && AboutSummary[0].label,
      values: AboutSummary.length && AboutSummary[0].values,
    };
    AboutSummaryModule.values && data.sections.unshift(AboutSummaryModule);
    data.extraData = {
      generalAdvice: generalAdviceModule,
      adNo: { values: [data.card.post_id] },
    };
  }
  if (data.extraData == undefined) {
    data.extraData = {
      seoData: {},
    };
  }
  data.extraData.seoData = {
    postId: data.card.post_id,
    pageTitle,
    description: AboutSummary.length && AboutSummary[0].values[0],
    postUrl: `/${data.lang}${reqUrl}`,
    link2: `/${lang == "ar" ? "en" : "ar"}${reqUrl}`,
  };
  return data;
};

export const getJobPosterPost = async (
  //server
  context: NextPageContextEnhanced,
  postId: string,
  abBucket?: string
): Promise<IJobPosterPostView> => {
  let url = `jobs/recruiter/v1/view/${postId}?expand=${JOB_POSTER_EXPANDS.join(
    ","
  )}&abBucket=${abBucket ? abBucket : 10}`;
  const data = await __fetchVerticalServerSide(url, context).then((data) => {
    data.result.data.isFullLoaded = true;
    data.result.data.isQuickPost = false;
    return data.result.data;
  });
  return enhancedJobPosterResponse(
    data,
    context.getData("source"),
    context.lang,
    context.req.url
  );
};
export const getJobPosterPostClientSide = async (
  postId: string | number,
  source: string,
  lang: string,
  reqUrl: string,
  abBucket?: string
): Promise<IJobPosterPostView> => {
  let url = `jobs/recruiter/v1/view/${postId}?expand=${JOB_POSTER_EXPANDS.join(
    ","
  )}&abBucket=${abBucket ? abBucket : 10}`;
  const data = await fetchVerticalAtClientSide<any>({
    url,
  }).then((data) => {
    return data.result.data;
  });

  return enhancedJobPosterResponse(data, source, lang, reqUrl);
};

export const getJobSeekerPost = async (
  //server
  context: NextPageContextEnhanced,
  cvId: any,
  abBucket?: string
): Promise<IJobSeekerPostView> => {
  let url = `jobs/seeker/v1/view/${cvId}?expand=${JOB_SEEKER_EXPANDS.join(
    ","
  )}&abBucket=${abBucket ? abBucket : 10}`;
  const data = await __fetchVerticalServerSide(url, context).then((data) => {
    data.result.data.isFullLoaded = true;
    data.result.data.isQuickPost = false;
    return data.result.data;
  });
  return enhancedJobSeekerResponse(
    data,
    context.getData("source"),
    context.lang,
    context.req.url
  );
};
export const getJobSeekerPostClientSide = async (
  cvId: string | number,
  source: string,
  lang: string,
  reqUrl: string,
  abBucket?: string
): Promise<IJobSeekerPostView> => {
  let url = `jobs/seeker/v1/view/${cvId}?expand=${JOB_SEEKER_EXPANDS.join(
    ","
  )}&abBucket=${abBucket ? abBucket : 10}`;

  const data = await fetchVerticalAtClientSide<any>({
    url,
  }).then((data) => {
    return data.result.data;
  });
  return enhancedJobSeekerResponse(data, source, lang, reqUrl);
};

export const getJobSeekerSimilar = async (
    context: NextPageContextEnhanced,
    postId: number | string | string[],
    page: number = 1,
    perPage: number = 9
): Promise<IOpeningJobsSimilarPostData> => {
  let url = `job-seeker/v1/${postId}/similar?page=${page}&per-page=${perPage}`;
  const data = await __fetchVerticalServerSide(url,context);
  if ("result" in data) return data.result.data;
  return null;
};
export const getJobSeekerSimilarClientSide = async (
    postId: number | string | string[],
    page: number = 1,
    perPage: number = 9
): Promise<Array<IJobsSimilarPost>> => {
  let url = `job-seeker/v1/${postId}/similar?page=${page}&per-page=${perPage}`;
  const data = await fetchVerticalAtClientSide<any>({url})
  if("result" in data){
    return  data?.result?.data?.items
  }
  return null

};

export const getJobPosterSimilar = async (
    context: NextPageContextEnhanced,
    postId: number | string | string[],
    page: number = 1,
    perPage: number = 9
): Promise<IOpeningJobsSimilarPostData> => {
  let url = `job-poster/v1/${postId}/similar?page=${page}&per-page=${perPage}&abBucket=10`;
  const data = await __fetchVerticalServerSide(url,context);
  if ("result" in data) return data.result.data;
  return null;
};
export const getJobPosterSimilarClientSide = async (
    postId: number | string | string[],
    page: number = 1,
    perPage: number = 9
): Promise<Array<IJobsSimilarPost>> => {
  let url = `job-poster/v1/${postId}/similar?page=${page}&per-page=${perPage}&abBucket=10`;
  const data = await fetchVerticalAtClientSide<any>({url})
  if("result" in data){
    return  data?.result?.data?.items
  }
  return null

};

export const getJobPosterRecommended = async (
  context: NextPageContextEnhanced,
  postId: number | string | string[],
  page: number = 1,
  perPage: number = 9
): Promise<IOpeningJobsRecommendedPostData> => {
  let url = `job-poster/v1/${postId}/recommended?page=${page}&per-page=${perPage}&abBucket=10`;
  const data = await __fetchVerticalServerSide(url,context);
  if ("result" in data) return data.result.data;
  return null;
};

export const getCvAsBinary = async (
  //server
  context: NextPageContextEnhanced,
  cvId: string
): Promise<any> => {
  let url = `jobs/seeker/v1/export-cv/${cvId}`;
  const data = await __fetchArrayBuffer(url, context);
  return data;
};

export const getCvScoreServeSide = async (
    context: NextPageContextEnhanced,
): Promise<IOpeningJobsRecommendedPostData> => {
  if (!context?.memberData?.id) return null
  const url = `jobs/v1/completion-score`;
  const data = await __fetchVerticalServerSide(url,context);
  return data?.result?.data?.score;
};